/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfoLink_viewer = {
    readonly buyerItemConversation?: {
        readonly serviceId: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_viewer">;
    readonly " $refType": "PdpSharedShippingInfoLink_viewer";
};
export type PdpSharedShippingInfoLink_viewer$data = PdpSharedShippingInfoLink_viewer;
export type PdpSharedShippingInfoLink_viewer$key = {
    readonly " $data"?: PdpSharedShippingInfoLink_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfoLink_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedShippingInfoLink_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "itemId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchUser",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "buyerItemConversation",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            },
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId"
            }
          ],
          "concreteType": "Conversation",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "serviceId",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'bba6624e8b326d6705a50ef22e749ac5';
export default node;
